/**
 * Mobile: #nav-top is position: fixed (see app.css). Reserves its height in the header
 * via --be-nav-top-h and toggles html.be-top-scrolled for the drop shadow.
 */
export function initStickyTopBar() {
  const navTop = document.querySelector('#root #nav-top');
  if (!navTop) return;

  const header = navTop.parentElement;
  const html = document.documentElement;

  const syncHeight = () => {
    header.style.setProperty('--be-nav-top-h', `${navTop.offsetHeight}px`);
  };
  syncHeight();
  if ('ResizeObserver' in window) new ResizeObserver(syncHeight).observe(navTop);

  const syncScrolled = () => {
    html.classList.toggle('be-top-scrolled', window.scrollY > 0);
  };
  syncScrolled();
  window.addEventListener('scroll', syncScrolled, { passive: true });
}
